<template>
  <div
    v-if="!pageLoading"
    class="job-profile-search"
  >
    <v-text-field
      :model-value="localInputValue"
      class="job-profile-search-field"
      density="compact"
      :min-width="260"
      flat
      hide-details
      placeholder="Search job profiles..."
      variant="outlined"
      @update:model-value="localInputValue = $event"
      @keydown.enter.prevent="submitSearch"
    >
      <template #append-inner>
        <DpplNewButton
          color="primary"
          size="small"
          class="apply-search-button"
          @click="submitSearch"
        >
          Apply
        </DpplNewButton>
      </template>
    </v-text-field>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useFilters } from '@/stores/filters/filters';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

const router = useRouter();

const { sendFilterRequest, setSearchTerm } = useFilters();
const { searchTerm } = storeToRefs(useFilters());
const { pageLoading } = storeToRefs(useAppLoading());

const localInputValue = ref('');

const submitSearch = () => {
  const value = (localInputValue.value).trim();

  setSearchTerm(value);
  sendFilterRequest({ router });
};

watch(() => searchTerm.value, (newVal, oldVal) => {
  const newSearchTerm = newVal || '';
  const oldSearchTerm = oldVal || '';

  if (newSearchTerm !== oldSearchTerm) {
    localInputValue.value = newSearchTerm;
  }
});
</script>

<style lang="less" scoped>
.job-profile-search-field {
  :deep(.v-field) {
    background-color: @bg-default;
    border: 1px solid @stroke-default;
    border-radius: 4px;
    height: 36px;
    min-height: 36px;
    padding: 0 6px 0 12px;
  }

  :deep(.v-field__field) {
    align-items: center;
  }

  :deep(.v-field__input) {
    padding: 0;
    font-size: 14px;
    min-height: 0px;
    color: @text-darkest;

    &::placeholder {
      color: @text-light;
    }
  }

  :deep(.v-field__outline) {
    display: none;
  }

  :deep(.v-field__append-inner) {
    padding-left: 12px;
    display: flex;
    align-items: center;
    align-self: stretch;
  }

  .apply-search-button {
    height: 28px;
  }
}
</style>
